module.exports = __webpack_public_path__ + "img/check-circle-fill-violet.b57ab737.svg";